import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewsBlockComponent } from './news-block.component';


import { ScrollModule } from 'app/shared/scroll/scroll.module';


@NgModule({
    imports: [
    CommonModule,
    ScrollModule,
    NewsBlockComponent
],
    exports: [
        NewsBlockComponent
    ]
})
export class NewsBlockModule { }
